export const statusTranslations = {
  delivery_proof: 'Accusé de réception',
  returned_to_sender: "Renvoyé à l'expéditeur",
  distributed: 'Distribué',
  sent: 'Envoyé',
  in_transit: 'En cours d’acheminement',
  created: 'Créé',
  accepted: 'Accepté',
  waiting_to_be_withdrawn: "En attente d'être récupéré",
  filing_proof: 'Preuve de dépôt',
  not_distributed: 'Non distribué',
  wrong_address: 'Mauvaise adresse',
  canceled: 'Annulé',
  return_to_sender_proof: "Retour à l'expéditeur",
  'electronic.sent': 'Lettre électronique envoyée',
  'electronic.refused': 'Lettre électronique refusée',
  'electronic.accepted': 'Lettre électronique acceptée',
  'electronic.negligence': 'Lettre électronique ignorée',
  'electronic.not_distributed': 'Problème de distribution electrronique',
  'electronic.locked': 'Bloqué erreur code',
  'electronic.failed_internal': 'Erreur interne electronique',
  'electronic.failed_tracking': 'Tracking impossible electronique',
  'electronic.failed_external': 'Erreur externe electronique',
}

export function translateToEnglish(value) {
  const entry = Object.entries(statusTranslations).find(
    ([_, translation]) => translation === value
  )
  return entry ? entry[0] : value
}

export function translateToFrench(key) {
  return statusTranslations[key] || key
}
